import gql from 'graphql-tag';
import apollo from 'src/features/apollo';

const query = gql`
query getCurrentUser {
  me {
    id
    email
    role
    firstName
    lastName
    fullName
    displayName
    absenceReason
    ready
    external
    sipUrl
    sipPassword
  }
}`;

function parseUser(item) {
  return {
    id: item.id,
    email: item.email,
    absenceReason: item.absenceReason,
    firstName: item.firstName,
    lastName: item.lastName,
    fullName: item.fullName,
    displayName: item.displayName,
    ready: item.ready,
    role: item.role,
    external: item.external,
    sipUrl: item.sipUrl,
    sipPassword: item.sipPassword,
  };
}

function getCurrentUser() {
  return apollo.client.query({
    query,
    fetchPolicy: 'network-only',
  }).then((res) => parseUser(res.data.me));
}

export default getCurrentUser;
